export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";